<template>
  <ion-row
    v-if="id in $store.state.errors"
    class="form-error ion-align-items-center ion-margin-bottom"
  >
    <ion-col size="auto">
      <ion-icon :icon="alertCircle"></ion-icon>
    </ion-col>
    <ion-col>
      <div class="" :id="id + '-error'" v-html="$store.state.errors[id]"></div>
    </ion-col>
  </ion-row>
</template>

<script>
import { IonRow, IonCol, IonIcon } from "@ionic/vue";
import { alertCircle } from "ionicons/icons";

export default {
  components: {
    IonRow,
    IonCol,
    IonIcon,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      alertCircle,
    };
  },
};
</script>

<style scoped></style>
